import { render, staticRenderFns } from "./GibAirList.vue?vue&type=template&id=7deb466e"
import script from "./GibAirList.vue?vue&type=script&lang=js"
export * from "./GibAirList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports